import { Icon } from '@eventbrite/eds-icon';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

import './CategoryEventsHeader.scss';

interface CategoryEventsHeaderProps {
    icon?: JSX.Element;
    title?: string | GenericLazyString;
    dataTestId?: string;
}

export const CategoryEventsHeader: React.FunctionComponent<
    CategoryEventsHeaderProps
> = (props) => {
    return (
        <div className="category-event-header" data-testid={props?.dataTestId}>
            <div className="header-tile">
                {props?.icon && (
                    <aside className="header-tile--icon">
                        <Icon type={props?.icon} size="medium" />
                    </aside>
                )}

                <div className="header-tile--name eds-text-hs">
                    {props?.title}
                </div>
            </div>

            {props.children}
        </div>
    );
};
